<div class="p-grid">
    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">Country Id</div>
        {{countryDetail?.countryId}}
    </div>
    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">Country Name</div>
        {{countryDetail?.countryName}}
    </div>
</div>

<div class="p-grid">
    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">Is Active</div>{{countryDetail?.isActive}}
    </div>
</div>